<template>
	<div class="item-upsell-container">
		<div class="content-message" :aria-label="mobileMessage" tabindex="0" v-if="upsell">
			{{ mobileMessage }}
		</div>
		<div class="content-image" v-if="item">
			<img :src="getItemImage" :alt="`${item.name} image`">
		</div>
		<div class="content-actions">
			<BaseButton title="Yes! 👍"
				:bigBtn="true"
				@click.native="confirmUpsell" />
			<BaseButton title="No, thank you."
				:bigBtn="true"
				@click.native="rejectUpsell" />
		</div>
	</div>
</template>

<script>
	import { mapGetters, mapActions } from 'vuex';
	import { CART, CART_OPTION, MENU_OPTIONS } from '@/stores/defs';
	import discountMixin from '@Mixin/discountMixin';
	import upsellService from '@/services/upsell.service';
	// TODO consider replacing velocity with anime
	import Velocity from 'velocity-animate';
	import 'velocity-animate/velocity.ui.min';

	export default {
		mixins: [discountMixin],
		props: {
			upsell: {
				type: Object,
				default: null,
			},
			item: {
				type: Object,
				default: null,
			},
		},
		computed: {
			...mapGetters({
				cartItem: CART.GET_CURRENT_ITEM,
				cartItemOptions: CART_OPTION.GET_ALL,
				optionChoices: MENU_OPTIONS.GET_CHOICES,
			}),
			mobileMessage() {
				const upsell = this.upsell;
				const rule = upsell.rules[0];
				return rule.mobileMessage;
			},
			getItemImage() {
				const isMobile = (this.$mq === "mobile");
				const standardImage = this.item.image;
				const fullSizeImage = this.item.fullSizeImage;
				return (isMobile && fullSizeImage) ? fullSizeImage : standardImage;
			}
		},
		methods: {
			...mapActions({
				addOptionChoice: CART_OPTION.ADD_CHOICE,
			}),
			confirmUpsell() {
				this.addUpsellOption();
				this.addUpsellDiscount();
				this.closeUpsell();
			},
			addUpsellOption() {
				const cartItem = this.cartItem;
				const options = this.cartItemOptions;
				const upsell = this.upsell;

				const option = upsell.getOptionFromRuleSet(options);
				const rule = upsell.itemRule(cartItem.getIds());
				const optionChoices = this.optionChoices(option.id);

				const upgradeChoice = upsell.getUpgradeChoice(optionChoices, rule);
				if (!upgradeChoice) {
					console.error(`upgrade choice ${rule.targetChoiceId} not available for option: ${option.name}`);
					return;
				}
				this.addOptionChoice({
					choice: upgradeChoice,
				});
			},
			addUpsellDiscount() {
				const cartItem = this.cartItem;
				const upsell = this.upsell;
				const amount = upsell.getDiscountAmount(cartItem.getIds());
				if (amount === 0) {
					return;
				}
				const discount = this.createDiscount(amount, upsell.name, `upsell_id:${upsell.id}`);
				cartItem.addDiscount(discount);
			},
			rejectUpsell() {
				const upsell = this.upsell;
				const action = 'attempt';
				this.$tpa.trackCartUpsell(`id: ${upsell.id} - action: ${action}`);
				upsellService.updateUpsell(upsell.id, action);
				this.closeUpsell();
			},
			closeUpsell() {
				this.$modal.hide('contentModal');
			},
		},
		mounted() {
			const content = this.$el;
			Velocity(content, {
				opacity: 0,
			}, {
				duration: 600,
				complete: () => {
					Velocity(content, {
						opacity: 1,
					}, {
						duration: 600,
						complete: () => {
							window.scrollTo(0,0);
						}
					});
				}
			});
		}
	}
</script>

<style lang="scss" scoped>
	@import 'globalStyles';
	.item-upsell-container {
		display: flex;
		flex-direction: column;
		position: relative;

		height: auto;
		opacity: 0;
		.content-message {
			position: absolute;
			top: 0;
			margin: 1em;
			padding: 6px;
			border-radius: 4px;

			font-weight: bold;
			font-size: 1.1em;
			z-index: 1;
		}
		.content-image {
			display: flex;
			justify-content: center;
			position: relative;

			width: 100%;
			margin: auto;

			img {
				opacity: 0.3;
				filter: blur(6px);
			}
		}
		.content-actions {
			position: absolute;
			bottom: 0;
			padding: 2em;

			width: 100%;
			z-index: $zTopInteractionLayer + 1;
		}
	}
	@include mobile {
		.item-upsell-container {
			margin-top: 2em;
			max-width: 100vw;
			z-index: $zTopInteractionLayer;
		}
	}
	@include phone {
		.item-upsell-container {
			.content-message {
				position: relative;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/menu/CartItemUpsell.vue